import logo from './logo.svg';
import './App.css';
import MainRouter from './MainRouter';
import React from "react";

function App() {
  return (
    <React.Fragment>
      <MainRouter/>
    </React.Fragment>
  );
}

export default App;
